import React, { Component } from 'react'
import styled from 'styled-components'
import FullWidthSection from '../UI/FullWidthSection'
import CustomBlockQuote from '../UI/blockquote'
import Slider from '../UI/slider'
import CtaButtonLg from '../UI/CtaButtonLg'

class TestimonialSection extends Component {
  render() {
    return (
      <TestimonialSectionContainer>
        <FullWidthSection bgColor={'#f6f6f6'}>
          <h2 className="section-title" style={{ textAlign: 'center' }}>
            World class teams use AppTree.
          </h2>
          <div className="customersBlurb">
            <div className="quote-grid">
              {/*<img src={icons.mobile_apps} alt="wireframe" />*/}
              <Slider />
              <CtaButtonLg to={'/customers'}>
                See Who's Using AppTree
              </CtaButtonLg>
            </div>
          </div>
        </FullWidthSection>
      </TestimonialSectionContainer>
    )
  }
}

export default TestimonialSection

const TestimonialSectionContainer = styled.div`
  .customersBlurb {
  }
  .quote-grid {
    display: flex;
    flex-direction: column;

    & div:last-child {
      align-self: center;
    }

    @media screen and (max-width: 762px) {
      display: flex;
      flex-direction: column;
      width: 80%;
      margin: auto;
      align-items: center;
    }
  }
`



// WEBPACK FOOTER //
// ./src/components/IndexContent/testimonial_section.jsx